import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MuException } from 'src/app/components/shared/types/exception.type';
import { FileUpload } from 'primeng/fileupload';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { UntypedFormGroup } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-file-upload-deliveries-form',
  templateUrl: './file-upload-form.component.html',
  styleUrls: ['./file-upload-form.component.sass']
})
export class FileUploadDeliveriesFormComponent<FlagType> extends MuComponent {

  @Output() fileEvent = new EventEmitter<File>();
  @Input() formData: UntypedFormGroup;
  @Input() flagList: Flags<FlagType>;
  @Input() uploadFileFlag: FlagType;
  @Input() fileFormatsAllowedToUpload: string;
  @Input() fileUploadedFlag: FlagType;
  @Input() modalFlag: FlagType;

  fileUploaded: boolean;
  fileId: string;
  file: File;
  fileControl: FileUpload;

  constructor() {
    super();
    this.fileUploaded = false;
  }

  muOnInit():void {
    this.watch( this.flagList.valueChanges(this.modalFlag) ).subscribe( show =>{
      if ( show ) {
        this.fileId = uuidv4();
        this.flagList.disable(this.fileUploadedFlag);
        this.flagList.disable(this.uploadFileFlag);
      }
    });
  }

  /**
   * called to enable the create service button
   * @returns void
   */
  handleFilePending():void {
    this.fileUploaded = false;
  }

  /**
   * 
   * @param {FileUpload} control 
   * @param $event 
   * @returns Promise<void>
   */
  async eventLoadExcelFile(control: FileUpload, $event): Promise<void> {
    this.fileControl = control;
    this.flagList.enable(this.fileUploadedFlag);
    try {
      this.setFile($event.files[0]);
    } catch (e) {
      control.clear();
      throw new MuException(e);
    }
  }

  /**
   * cancells the file upload
   * @param {FileUpload} control 
   * @returns void
   */
  cancelLoad(control: FileUpload):void {
    if ( !this.flagList.get(this.uploadFileFlag) ) {
      this.deleteFile();
      control.clear();
      this.flagList.disable(this.modalFlag);
    }
  }
    

  /**
   * set uploaded file
   * @param {File} file `
   * @returns void
   */

  setFile(file: File):void {
    this.file = file;
    this.formData.patchValue({
      file: file
    });
    this.fileUploaded = true;
    this.flagList.enable(this.fileUploadedFlag);
  }
  
  /**
  * Delete the loaded file
  * @returns void
  */
  deleteFile():void {
    this.formData.patchValue({
      file: null
    });
    this.file = null;
    this.fileUploaded = false;
  }

  muOnDestroy(): void {
    /** */
  }

}
